import React from 'react'
import ServicePlanManagement from '../../../components/ServicePlanManagement/ServicePlanManagement';

const ServicePlans = ({ title }) => {
    return (
        <ServicePlanManagement />
    )
}

export default ServicePlans;
